import {
  APPUSER_ACCESS,
  APPUSER_OWN_ORDERS,
  APPUSER_ACCESSED_TICKETS
} from '../actions';

export const appuserAccess = (state = {}, action) => {
  if (action.type === APPUSER_ACCESS) return action.payload;
  return state;
};

export const ownOrders = (state = {}, action) => {
  if (action.type === APPUSER_OWN_ORDERS) return action.payload;
  return state;
};

export const appuserAccessedTickets = (state = [], action) => {
  if (action.type === APPUSER_ACCESSED_TICKETS) return action.payload;
  return state;
};
